import React from "react";
import AxiosConfig from "axiosConfig";
import ProjectCompleteComponent from "components/Project/ActiveProject/ProjectComplete/ProjectCompleteComponent";

/**
 * @description Displays the prize earned by a user after completion of a project.
 * @class ProjectComplete
 * @implements ProjectCompleteComponent
 * @extends React.Component
 * @type {ProjectComplete}
 * @example <ProjectComplete />
 * pre-condition: all the imports
 * post-condition: saves the prize earned by the user.
 * @param null
 * @returns {ProjectComplete}
 */

class ProjectComplete extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      projectSlug: this.props.match.params.slug,
      projectName: "",
      projectBanner: "",
      projectBadge: "",
      projectMission: "",
      image: "",
      invitees: [],
      video: "",
      description: "",
      adventureId: this.props.location.state.adventureId,
      adventureSlug: this.props.location.state.adventureSlug,
      challengeSlug: this.props.location.state.challengeSlug,
      projectUserId: this.props.location.state.projectUserId,
      challenge_slug:undefined,
      goal_date:undefined,
      project_user_id:undefined,
      imageList: [
        {
          challenge_slug: "",
          challenge_image: "",
        },
      ],
    };
  }
  getActiveProjectList() {
    AxiosConfig.get(`/impactprojects/project/${this.state.projectSlug}/`)
      .then((res) => {
        this.setState({
          projectName: res.data.name,
          projectBanner: res.data.banner,
          projectBadge: res.data.badge,
          projectMission: res.data.mission,
        });
      })
      .catch();
  }
  getProjectCompleteDetails() {
    let formData = new FormData();
    formData.append("adventure", this.state.adventureId);
    AxiosConfig.get(
      `/impactprojects/Congratulations/${this.state.projectSlug}/${this.state.projectUserId}`,
      formData
    )
      .then((res) => {
        if (res.data) {
          this.setState({
            image: res.data.image,
            adventureId: res.data.adventure_id,
          });
          if (this.state.adventureSlug === "SPREAD_THE_WORD") {
            this.setState({
              invitees: res.data.invitees,
              video: res.data.video,
            });
          }
        }
      })
      .catch();
  }
  getCurrentChallengeDetails() {
    AxiosConfig.get(
      `/impactprojects/active_challenge_details/${this.state.projectSlug}`
    )
      .then((res) => {        
        if (res.data.length>0) {
          const list = res.data[0];
          this.setState({
            challenge_slug:list.challenge.slug,
            goal_date:list.goal_date,
            project_user_id:list.project_user_id
          });
        }
      })
      .catch();
  }
  componentDidMount() {
    this.getActiveProjectList();
    this.getProjectCompleteDetails();
    this.getCurrentChallengeDetails();
  }

  saveHandler(event) {
    this.props.history.push({
      pathname: `/projects/${this.state.projectSlug}/challenges`,
      state: {
        adventureId: undefined,
        adventureSlug: undefined,
        challengeSlug: this.state.challenge_slug,
        projectUserId: this.state.project_user_id,
        goalDate:this.state.goal_date
      },
    });
  }

  render() {
    return (
      <ProjectCompleteComponent
        projectBanner={this.state.projectBanner}
        projectBadge={this.state.projectBadge}
        projectName={this.state.projectName}
        projectMission={this.state.projectMission}
        adventureId={this.state.adventureId}
        adventureSlug={this.state.adventureSlug}
        projectSlug={this.state.projectSlug}
        challengeSlug={this.state.challengeSlug}
        image={this.state.image}
        invitees={this.state.invitees}
        video={this.state.video||this.state.projectBanner}
        saveHandler={this.saveHandler.bind(this)}
        projectUserId={this.state.projectUserId}
      />
    );
  }
}

export default ProjectComplete;
